import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { useLanguage } from '../../../contexts/LanguageContext';

const AnalysisCard = ({ 
  analysis,
  onViewDetails 
}) => {
  const { t } = useLanguage();

  const getVerdictConfig = (verdict) => {
    const configs = {
      'Fair': {
        color: 'text-success',
        bgColor: 'bg-success/10',
        icon: 'CheckCircle2'
      },
      'Aggressive': {
        color: 'text-warning',
        bgColor: 'bg-warning/10',
        icon: 'AlertTriangle'
      },
      'Risky': {
        color: 'text-error',
        bgColor: 'bg-error/10',
        icon: 'AlertCircle'
      },
      'Pending': {
        color: 'text-muted-foreground',
        bgColor: 'bg-muted',
        icon: 'Clock'
      }
    };
    return configs?.[verdict] || configs?.['Pending'];
  };

  const verdictConfig = getVerdictConfig(analysis?.verdict);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleDateString('en-AU', { 
      day: '2-digit', 
      month: '2-digit', 
      year: 'numeric' 
    });
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-5 lg:p-6 shadow-elevation-sm hover:shadow-elevation-md transition-base">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <div className="flex-1 min-w-0">
          <div className="flex items-start gap-3 mb-3">
            <div className="flex-shrink-0 mt-1">
              <Icon name="MapPin" size={20} color="var(--color-primary)" />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-base md:text-lg font-semibold text-foreground font-heading truncate mb-1">
                {analysis?.address}
              </h3>
              <p className="text-sm text-muted-foreground text-caption">
                {analysis?.suburb}
              </p>
            </div>
          </div>

          <div className="flex flex-wrap items-center gap-3 md:gap-4">
            <div className="flex items-center gap-2">
              <Icon name="Calendar" size={16} color="var(--color-muted-foreground)" />
              <span className="text-sm text-muted-foreground text-data">
                {formatDate(analysis?.date)}
              </span>
            </div>

            <div className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-lg ${verdictConfig?.bgColor}`}>
              <Icon name={verdictConfig?.icon} size={16} color={`var(--color-${analysis?.verdict === 'Fair' ? 'success' : analysis?.verdict === 'Aggressive' ? 'warning' : analysis?.verdict === 'Risky' ? 'error' : 'muted-foreground'})`} />
              <span className={`text-sm font-medium ${verdictConfig?.color} text-caption`}>
                {analysis?.verdict}
              </span>
            </div>

            {analysis?.confidenceScore && (
              <div className="flex items-center gap-2">
                <Icon name="TrendingUp" size={16} color="var(--color-muted-foreground)" />
                <span className="text-sm text-muted-foreground text-data">
                  {analysis?.confidenceScore}% {t('confidence')}
                </span>
              </div>
            )}
          </div>

          {analysis?.portal && (
            <div className="mt-3 flex items-center gap-2">
              <Icon name="Globe" size={14} color="var(--color-muted-foreground)" />
              <span className="text-xs text-muted-foreground text-caption">
                {t('source')}: {analysis?.portal}
              </span>
            </div>
          )}
        </div>

        <div className="flex-shrink-0">
          <Button
            variant="outline"
            size="default"
            iconName="ArrowRight"
            iconPosition="right"
            onClick={() => onViewDetails(analysis?.id)}
            className="w-full lg:w-auto"
          >
            {t('viewDetails')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AnalysisCard;